module.exports = __webpack_public_path__ + "static/media/background_img.b8457bb7.jpeg";